// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"TeamSearchBar_searchBar__3iG0_"};